import { render, staticRenderFns } from "./examineModal.vue?vue&type=template&id=c48aff0e&scoped=true&"
import script from "./examineModal.vue?vue&type=script&lang=js&"
export * from "./examineModal.vue?vue&type=script&lang=js&"
import style0 from "./examineModal.vue?vue&type=style&index=0&id=c48aff0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48aff0e",
  null
  
)

export default component.exports